module.exports = __webpack_public_path__ + "img/post.2366aece.svg";